import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import "../styles/components/Navbar.css";

const Navbar = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);

  const openNav = () => setIsNavOpen(true);
  const closeNav = () => setIsNavOpen(false);
  const toggleNav = () => setIsNavOpen((v) => !v);

  // Lock body scroll when menu is open (mobile)
  useEffect(() => {
    if (isNavOpen) document.body.style.overflow = "hidden";
    else document.body.style.overflow = "";
    return () => (document.body.style.overflow = "");
  }, [isNavOpen]);

  // Close on ESC
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Escape") closeNav();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);

  const linkClass = ({ isActive }) => `nav-link${isActive ? " active" : ""}`;

  return (
    <nav className="navbar navbar-expand-lg navbar-light">
      {/* Toggle button (Bootstrap icon still works) */}
      <button
        className="navbar-toggler"
        type="button"
        onClick={toggleNav}
        aria-expanded={isNavOpen ? "true" : "false"}
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon" />
      </button>

      {/* Backdrop */}
      <div
        className={`nav-backdrop ${isNavOpen ? "show" : ""}`}
        onClick={closeNav}
        aria-hidden="true"
      />

      {/* Drawer / Menu */}
      <div className={`overlay-nav ${isNavOpen ? "show" : ""}`}>
        <div className="mobile-nav-header">
          <span className="mobile-nav-title">Menu</span>
          <button className="mobile-nav-close" onClick={closeNav} aria-label="Close menu">
            ✕
          </button>
        </div>

        <ul className="navbar-nav">
          <li className="nav-item">
            <NavLink to="/" end className={linkClass} onClick={closeNav}>
              Home
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink to="/ServicesPage" className={linkClass} onClick={closeNav}>
              Services
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink to="/CareersPage" className={linkClass} onClick={closeNav}>
              Careers
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink to="/AboutUsPage" className={linkClass} onClick={closeNav}>
              About Us
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink to="/ContactUsPage" className={linkClass} onClick={closeNav}>
              Contact Us
            </NavLink>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
